// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.code-verification-container {
    position: fixed;
    top: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    margin-top: 0;
    right: 0;
    padding-right: 0;
    height: 100%;
    width: 500px;
    background-color: #202124;
    opacity: 95%;
    z-index: 50;
}

.code-verification-title {
    padding-top: 100px;
}

.code-verification-subtitle {
    font-size: 14pt;
    color: var(--color-grey000);
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
}

.code-verification-form {
    width: 100%;
    display: block;
}

.code-verification-email {
    margin-left: 25px;
    margin-right: 25px;
}

.code-verification-password {
    margin-left: 25px;
    margin-right: 25px;
}

.code-verification-buttons-container {
    display: flex;
    justify-content: flex-end;
    padding-top: 50px;
    margin-left: 25px;
    margin-right: 25px;
}

.code-verification-button-submit {
    width: 100%;
}

.code-verification-checkbox-remember-me {
    padding-top: 25px;
    padding-bottom: 0;
    color: var(--color-grey000);
}

.code-verification-validation-error-text {
    color: var(--color-warning);
    ;
}

/* Media Query for smaller screens */
@media (max-width: 500px) {
    .code-verification-container {
        position: fixed;
        top: 0;
        padding-top: 0;
        padding-bottom: 0;
        margin-bottom: 0;
        margin-top: 0;
        padding-right: 0;
        height: 100%;
        width: 100%;
        background-color: #202124;
        opacity: 95%;
        z-index: 50;
    }

    .code-verification-title {
        padding-top: 50px;
        padding-bottom: 20px;
        font-size: large;
    }

    .code-verification-form {
        width: 100%;
        display: block;
    }

    .code-verification-email {
        margin-left: 25px;
        margin-right: 25px;
    }

    .code-verification-password {
        margin-left: 25px;
        margin-right: 25px;
    }

    .code-verification-buttons-container {
        display: flex;
        justify-content: flex-end;
        padding-top: 50px;
        margin-left: 25px;
        margin-right: 25px;
    }

    .code-verification-button-submit {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/containers/CodeVerification.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,oBAAoB;IACpB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA,oCAAoC;AACpC;IACI;QACI,eAAe;QACf,MAAM;QACN,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;QACb,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".code-verification-container {\n    position: fixed;\n    top: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0;\n    margin-top: 0;\n    right: 0;\n    padding-right: 0;\n    height: 100%;\n    width: 500px;\n    background-color: #202124;\n    opacity: 95%;\n    z-index: 50;\n}\n\n.code-verification-title {\n    padding-top: 100px;\n}\n\n.code-verification-subtitle {\n    font-size: 14pt;\n    color: var(--color-grey000);\n    padding-bottom: 30px;\n    display: flex;\n    justify-content: center;\n}\n\n.code-verification-form {\n    width: 100%;\n    display: block;\n}\n\n.code-verification-email {\n    margin-left: 25px;\n    margin-right: 25px;\n}\n\n.code-verification-password {\n    margin-left: 25px;\n    margin-right: 25px;\n}\n\n.code-verification-buttons-container {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 50px;\n    margin-left: 25px;\n    margin-right: 25px;\n}\n\n.code-verification-button-submit {\n    width: 100%;\n}\n\n.code-verification-checkbox-remember-me {\n    padding-top: 25px;\n    padding-bottom: 0;\n    color: var(--color-grey000);\n}\n\n.code-verification-validation-error-text {\n    color: var(--color-warning);\n    ;\n}\n\n/* Media Query for smaller screens */\n@media (max-width: 500px) {\n    .code-verification-container {\n        position: fixed;\n        top: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n        margin-bottom: 0;\n        margin-top: 0;\n        padding-right: 0;\n        height: 100%;\n        width: 100%;\n        background-color: #202124;\n        opacity: 95%;\n        z-index: 50;\n    }\n\n    .code-verification-title {\n        padding-top: 50px;\n        padding-bottom: 20px;\n        font-size: large;\n    }\n\n    .code-verification-form {\n        width: 100%;\n        display: block;\n    }\n\n    .code-verification-email {\n        margin-left: 25px;\n        margin-right: 25px;\n    }\n\n    .code-verification-password {\n        margin-left: 25px;\n        margin-right: 25px;\n    }\n\n    .code-verification-buttons-container {\n        display: flex;\n        justify-content: flex-end;\n        padding-top: 50px;\n        margin-left: 25px;\n        margin-right: 25px;\n    }\n\n    .code-verification-button-submit {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
